module.exports = __webpack_public_path__ + "static/img/akum_600_40.6a96307.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_40.svg
// module id = xFWU
// module chunks = 1